// ABOUTME: Filters the widgets of a custom page column down to those the user can see.
// ABOUTME: With `keepWidgetSlots`, the visible widgets take the layout slots of the configured list in order.

import { CustomPageWidget } from '../types';
import { isWidgetVisibleForRoles } from '../widgets/utils/widgetRoles';

// The config fields that size and space a widget's cell: with kept slots they belong to the
// position in the column, not to the widget.
const SLOT_CONFIG_KEYS = ['width', 'margin', 'padding', 'maxHeight'] as const;

/**
 * Drops the widgets hidden by `roles`. With `keepWidgetSlots`, the k-th visible widget is laid
 * out with the slot (width, margin, padding, maxHeight) of the k-th configured widget, so the
 * widgets that follow a hidden one move up into its place and the column keeps its shape.
 */
export function visibleWidgets(
    widgets: CustomPageWidget[],
    hasUserRole: (role: string) => boolean,
    keepWidgetSlots = false,
): CustomPageWidget[] {
    const visible = widgets.filter(widget =>
        isWidgetVisibleForRoles(
            widget.config as Record<string, unknown> | null | undefined,
            hasUserRole,
        ),
    );
    if (!keepWidgetSlots || visible.length === widgets.length) return visible;
    return visible.map((widget, index) => {
        const slotConfig = widgets[index].config;
        const slot = Object.fromEntries(
            SLOT_CONFIG_KEYS.map(key => [key, slotConfig?.[key] ?? undefined]),
        );
        return { ...widget, config: { ...widget.config, ...slot } } as CustomPageWidget;
    });
}
